module.exports = __webpack_public_path__ + "img/线上活动.703df552.png";